<div id="authenticator">

    

    <mat-card id="authenticator-content">
        <!-- Bouton Play/Pause -->
        
        <div class="box1">
            
        <div class="audio-container">
                <button class="play-pause-button" (click)="toggleAudio()">
                  <mat-icon>{{ isPlaying ? 'pause' : 'play_arrow' }}</mat-icon>
                </button>
                <audio #audioPlayer autoplay= "true" src="../../../assets/audio/02_Bambara_Connecter_Creer_Oublie.m4a"></audio>
              </div>    
            <img src="../../../assets/images/Lenali_logo_Full.png" alt=""  class="lenali-logo">
            <h4 style="font-weight: bold; color: #08a8ff;">Email et mot de passe</h4>
        </div>
        <mat-card-header>
            <mat-card-title>{{getStateText()}}</mat-card-title>
        </mat-card-header>
        <div *ngIf="isLoginState()">
            <input #loginEmail placeholder="Email"/>
            <input #loginPassword placeholder="Mot de passe" type="password">
            <button 
                (click)="onLogin(loginEmail, loginPassword)"
                class="btn-send">Se connecter</button>
                
            
        </div>
        <div *ngIf="isRegisterState()">
            <input #registerEmail placeholder="Email">
            <input #registerPassword placeholder="Mot de passe" type="password">
            <input #registerConfirmPassword placeholder="Confirmer mot de passe" type="password">
            <button 
                (click)="onRegisterClick(
                    registerEmail,
                    registerPassword,
                    registerConfirmPassword
                )"
            class="btn-send">Créer</button>
            
            
        </div>
        <div *ngIf="isForgotPasswordState()">
            <input #resetEmail placeholder="Email">
            <button (click)="onResetClick(resetEmail)" 
            class="btn-send" >Réinitialiser</button>
        </div>
        <mat-card-actions align="end">
            <button mat-flat-button
            (click)="onForgotPasswordClick()" style="font-size: 0.75rem; color: red;">Mot de passe oublié?</button>
            <button mat-flat-button
            (click)="onCreateAccountClick()" style="font-size: 0.75rem; color: green;">Créer un compte</button>
            <button mat-flat-button
            (click)="onLoginClick()" style="font-size: 0.75rem;">Se connecter</button>
        </mat-card-actions>
    </mat-card>
    <div style="margin-top:8px; font-size: 12px; color:#555;">
      <a routerLink="/faq" style="color:#08a8ff; text-decoration:none;">Besoin d'aide ? Consultez la FAQ</a>
    </div>
</div>